export default "__VITE_ASSET__e651b081__"